var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClutterCuate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.11,325.06,86,325.33l-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0L99,319.4c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.34,339.17l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.44l0-11.19v-.51h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27V328c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.42.05-8.83.16-13.24.16l-13.24.06.5-.49-.06,11.19-.44-.45c2.18,0,4.36,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.89,180.84l-13.12.27-6.66.12c-2.23,0-4.46,0-6.7.05H381v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,195l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7,0h-.44V195l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5L367.09,195l-.45-.45c2.18,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.41,180.84l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.14,339.17l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44L665.16,328v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V328c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.37,65.49l-13.12.27-6.67.12c-2.22,0-4.46,0-6.69.05h-.44v-.45l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.14,79.6,679,79.87l-6.66.12c-2.23,0-4.47,0-6.7.05h-.44V79.6l-.06-11.19V67.9h.5L678.9,68c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0L692,73.94c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,65.49,86,65.76l-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.45L72.13,54.3v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0L99,59.83c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19L72.63,65c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.12,253.82H80V57.89H213.12ZM83.93,249.87H209.17v-188H83.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.57,
    y: 62.87,
    width: 3.95,
    height: 188.97,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 68.38 76.39 71.38 76.39 65.88 216.7 65.88 216.7 68.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 71.57 76.39 77.57 76.39 72.07 216.7 69.07 216.7 71.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 74.76 76.39 83.76 76.39 78.25 216.7 72.25 216.7 74.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 77.94 76.39 89.94 76.39 84.44 216.7 75.44 216.7 77.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 81.13 76.39 96.13 76.39 90.63 216.7 78.63 216.7 81.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 84.32 76.39 102.32 76.39 96.82 216.7 81.82 216.7 84.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 88.51 76.39 108.51 76.39 103.01 216.7 86.01 216.7 88.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 93.7 76.39 114.7 76.39 109.2 216.7 91.2 216.7 93.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 96.89 76.39 120.89 76.39 115.39 216.7 94.39 216.7 96.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.98,
    y: 64.76,
    width: 0.99,
    height: 117.05,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.23 186.41 202.72 186.41 203.6 181.37 205.35 181.37 206.23 186.41",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.54,
    y: 64.76,
    width: 0.99,
    height: 144.05,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.79 212.52 206.28 212.52 207.16 207.48 208.91 207.48 209.79 212.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.26,
    y: 57.12,
    width: 152.57,
    height: 11.51,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.9 397.11 433.65 354.47 433.57 311.83 433.4 226.54 433.56 141.26 433.65 98.61 433.9 55.97 434.14 98.61 434.23 141.26 434.4 226.54 434.23 311.83 434.14 354.47 433.9 397.11",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.7,
    y: 79.3,
    width: 52.75,
    height: 63.99,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.73,
    y: 85.14,
    width: 40.7,
    height: 52.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.73,
    y: 85.14,
    width: 1.59,
    height: 52.31,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.46,
    y: 79.3,
    width: 1.59,
    height: 63.99,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.99,
    y: 97.24,
    width: 9.6,
    height: 28.59,
    transform: "translate(979.58 223.06) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.27,106.86H472.69v-15h26.58Zm-25.58-1h24.58v-13H473.69Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.23,
    y: 79.3,
    width: 52.75,
    height: 63.99,
    transform: "translate(0.54 -3.04) rotate(0.28)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.26,
    y: 85.14,
    width: 40.7,
    height: 52.31,
    transform: "matrix(1, 0, 0, 1, 0.54, -3.04)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.26,
    y: 85.04,
    width: 1.59,
    height: 52.31,
    transform: "translate(0.54 -2.93) rotate(0.27)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657.98,
    y: 79.43,
    width: 1.59,
    height: 63.99,
    transform: "translate(0.55 -3.19) rotate(0.28)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.9,
    y: 97.22,
    width: 9.6,
    height: 28.59,
    transform: "translate(0.54 -3.02) rotate(0.28)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.82,106.93l-26.59-.13.07-15,26.59.13Zm-25.58-1.12,24.58.11.07-13L621.3,92.8Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.28,
    y: 84.11,
    width: 52.75,
    height: 63.99,
    transform: "translate(-11.93 110.23) rotate(-11.17)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.31,
    y: 89.95,
    width: 40.7,
    height: 52.31,
    transform: "translate(-11.93 110.23) rotate(-11.17)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.68,
    y: 93.74,
    width: 1.59,
    height: 52.31,
    transform: "translate(-13.03 106.57) rotate(-11.17)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.52,
    y: 78.85,
    width: 1.59,
    height: 63.99,
    transform: "translate(-10.4 115.28) rotate(-11.17)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.28,
    y: 103.48,
    width: 8.22,
    height: 20.79,
    transform: "translate(-11.5 110.14) rotate(-11.17)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.07,132.52l-3-15L570.74,113l3,15Zm-1.8-14.25,2.58,13.08,20.69-4.09L570,114.19Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "161.7 300.68 163.96 314.23 179.26 396.88 181.73 396.88 170.6 314.23 168.96 300.68 161.7 300.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.96 300.68 161.7 300.68 163.96 314.23 170.6 314.23 168.96 300.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.64 396.88 116.1 396.88 131.41 314.23 133.67 300.68 126.41 300.68 124.77 314.23 113.64 396.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.41 300.68 124.77 314.23 131.41 314.23 133.67 300.68 126.41 300.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.73 396.88 70.19 396.88 85.5 314.23 87.76 300.68 80.5 300.68 78.86 314.23 67.73 396.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.86 314.23 85.5 314.23 87.76 300.68 80.5 300.68 78.86 314.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.64 307.04 183.79 307.04 183.79 295.23 141.81 295.23 127.7 213.13 75.91 213.13 71.64 307.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.64 307.04 77.75 307.04 81.74 213.13 75.91 213.13 71.64 307.04",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29.21 397.11 115.65 396.87 202.1 396.78 375 396.61 547.9 396.78 634.35 396.87 720.79 397.11 634.35 397.36 547.9 397.44 375 397.61 202.1 397.44 115.65 397.35 29.21 397.11",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 431.17,
    rx: 311.7,
    ry: 19.16,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bed--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 185.09,
    width: 198.9,
    height: 195.16,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.9,
    y: 185.09,
    width: 8.09,
    height: 228.16,
    transform: "translate(1293.9 598.35) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.1,
    y: 380.25,
    width: 8.09,
    height: 33,
    transform: "translate(950.29 793.5) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 380.25,
    width: 27.1,
    height: 33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.8,
    y: 380.25,
    width: 27.1,
    height: 33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.18,
    y: 350.83,
    width: 253.72,
    height: 29.43,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.28,
    y: 350.83,
    width: 198.9,
    height: 29.43,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.18,
    y: 380.25,
    width: 8.09,
    height: 33,
    transform: "translate(786.45 793.5) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.38,
    y: 380.25,
    width: 8.09,
    height: 33,
    transform: "translate(442.85 793.5) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.28,
    y: 380.25,
    width: 27.1,
    height: 33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.08,
    y: 380.25,
    width: 27.1,
    height: 33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.9,
    y: 302.25,
    width: 245.97,
    height: 48.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.64,
    y: 302.25,
    width: 189.26,
    height: 48.58,
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.64,
    y: 302.25,
    width: 189.26,
    height: 48.58,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,350.83V302.25h128c3.74,0,24.25,9.19,29.1,22.5,2.67,7.34,26.52,15.67,27.35,26.08,1.59,20.06-10.79,56.14-15.28,57s-11.14-27.55-17.7-37.58c-5.28-8.05-33.36-12.63-40.51-15.79s-9.65-3.33-17.3-3.33S383.9,350.83,383.9,350.83Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M550.43,333.35c-3.12.06-13.78.24-16.32,0-3-.32-9.09-1.46-11.55-1.35s-28.44,7.18-28.44,4.9c0-2.57,15.79-10.34,23.94-13s19.34-1.78,21.45-2.36h0a21,21,0,0,1,1.49,3.19C542,327.46,545.88,330.32,550.43,333.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M483.25,324.87c.58-4.17,15.08-5.74,16.18-4s-5.43,2.93-8.09,4S482.81,328.05,483.25,324.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M547.52,354c-1,3.77,0,11.19-2.66,13.41a89.34,89.34,0,0,0-7,7.37,38.21,38.21,0,0,0-2.49-4.6c-2.41-3.67-9.57-6.62-17.32-9.05,3.63.07,16.76-2.28,19.73-4.71s6.85-11.18,9.73-12.62S548.52,350.27,547.52,354Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M552.8,408l-.48-.29c10.94-16.29,12.94-52.26,10.83-58.55-1.26-2.91-13.07-11.06-17.51-14.13-3.2-2.21-4.92-3.4-5.89-4.27a13.17,13.17,0,0,1-3.49-5.27,18.12,18.12,0,0,0-4.15-6.29c-9.33-9.87-23.66-16.89-23.78-16.91l10-.57c.59.12,9-.7,20.34,11.3a26.79,26.79,0,0,1,5.9,9,4.84,4.84,0,0,0,1.2,2.07c.59.53,2.83,2.08,5,3.57,12.67,8.75,19.38,14,20.94,18.68,2.82,8.42-5.47,39.72-15.08,58.16A6.74,6.74,0,0,1,552.8,408Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M552.8,408l-.48-.29c10.94-16.29,12.94-52.26,10.83-58.55-1.26-2.91-13.07-11.06-17.51-14.13-3.2-2.21-4.92-3.4-5.89-4.27a13.17,13.17,0,0,1-3.49-5.27,18.12,18.12,0,0,0-4.15-6.29c-9.33-9.87-23.66-16.89-23.78-16.91l10-.57c.59.12,9-.7,20.34,11.3a26.79,26.79,0,0,1,5.9,9,4.84,4.84,0,0,0,1.2,2.07c.59.53,2.83,2.08,5,3.57,12.67,8.75,19.38,14,20.94,18.68,2.82,8.42-5.47,39.72-15.08,58.16A6.74,6.74,0,0,1,552.8,408Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M475.9,282.88c-2.1,1.84-6.31,4.32-3.23,5.71a15,15,0,0,0,6.68,1s26.06,6.24,44.83,9.83,54.16,6.86,55.92,6.91,5.13,2.89,6.44,2.58-.77-5.14-.64-6,9.16-13.63,12.84-22.35,5.36-17.91,5.77-18.94,5.68-5,4.39-6.47-9.08,1-9.76,1.06-32.23-12.5-50.89-15.11-45.32-2.75-46-2.85-7.51-4.2-9.42-3.55.53,7,.13,7.72-8.55,12.92-11.39,20.17S475.9,282.88,475.9,282.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.25,301.52s2-17.58,6.86-24.62,13-15,13-15-4.89,15.74-7.75,21.32C590.87,288.16,581.25,301.52,581.25,301.52Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Nightstand--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.28,
    y: 291.3,
    width: 94.21,
    height: 124.38,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.72,
    y: 286.46,
    width: 103.34,
    height: 4.84,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.06,
    y: 286.46,
    width: 32.5,
    height: 4.84,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.23,
    y: 311.92,
    width: 30,
    height: 33.6,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543.54,
    y: 303.97,
    width: 73.69,
    height: 41.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.36,345.65H543.42v-41.8h73.94Zm-73.69-.25h73.44V304.1H543.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.07,
    y: 316.07,
    width: 14.39,
    height: 8.27,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.84,323.84H574.2v-7.27h14.64Zm-14.39-.25h14.14v-6.77H574.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657.49,
    y: 291.3,
    width: 31.92,
    height: 124.38,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.36,398.13H573.42V356.34h73.94Zm-73.69-.25h73.44V356.59H573.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.07,
    y: 368.56,
    width: 14.39,
    height: 8.27,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.84,376.33H604.2v-7.27h14.64Zm-14.39-.25h14.14v-6.77H604.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.15,224c-10.31,10.1-12,25.72-9.87,39.41.06.31.54.22.54-.07,0-3.12-.1-6.2-.09-9.28.06-.14.11-.27.16-.41a20.63,20.63,0,0,0,6.7-7.2c1.73-3.39,2.4-7.21,3.72-10.75.12-.34-.24-.24-.47-.07-6.28,4.63-8.28,9.61-10.08,16.26a56.17,56.17,0,0,1,1.09-10.36c1.36-6.31,4-12.57,8.58-17.26A.19.19,0,0,0,678.15,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.09,225.15c1.78.06,2.89,2.9,4.27,3.73a1.33,1.33,0,0,0,2-.31c1.37-1.91-.51-4.27-2.28-5.59,1.27.52,2.32,1.43,3.68,1.69a1.28,1.28,0,0,0,1.66-1c.6-2.61-2.67-3.77-4.91-3.83,1.08-.75,4.2-2.81,2.55-3.82s-5.34,1.92-6.54,2.89c-1.75,1.43-3.84,3.55-3.92,5.78C676.46,227.3,678.73,225.7,680.09,225.15Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.09,225.15c1.78.06,2.89,2.9,4.27,3.73a1.33,1.33,0,0,0,2-.31c1.37-1.91-.51-4.27-2.28-5.59,1.27.52,2.32,1.43,3.68,1.69a1.28,1.28,0,0,0,1.66-1c.6-2.61-2.67-3.77-4.91-3.83,1.08-.75,4.2-2.81,2.55-3.82s-5.34,1.92-6.54,2.89c-1.75,1.43-3.84,3.55-3.92,5.78C676.46,227.3,678.73,225.7,680.09,225.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.58,225.59c2.27-1,6.63.46,7-.4.75-1.75-2.73-2.95-4.61-3.18,1.73-.47,5-1.22,4.94-2.89-.12-2-5.08-.28-7.6,1.64-3.16,2.43-3.14,4.77-2.62,5.24C677.41,226.64,679.21,225.76,679.58,225.59Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.58,225.59c2.27-1,6.63.46,7-.4.75-1.75-2.73-2.95-4.61-3.18,1.73-.47,5-1.22,4.94-2.89-.12-2-5.08-.28-7.6,1.64-3.16,2.43-3.14,4.77-2.62,5.24C677.41,226.64,679.21,225.76,679.58,225.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.66,223c10.69,9.7,13,25.24,11.37,39,0,.31-.53.25-.54,0-.12-3.12-.14-6.21-.27-9.28-.06-.14-.11-.27-.18-.41a20.75,20.75,0,0,1-7-6.94c-1.85-3.32-2.67-7.11-4.12-10.6-.14-.33.23-.25.47-.08,6.45,4.39,8.64,9.29,10.69,15.87a55.36,55.36,0,0,0-1.49-10.32c-1.59-6.26-4.51-12.41-9.22-16.92A.19.19,0,0,1,654.66,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.77,224.23c-1.77.13-2.78,3-4.13,3.88a1.33,1.33,0,0,1-2-.23c-1.44-1.86.35-4.29,2.07-5.68-1.25.57-2.26,1.52-3.61,1.83a1.28,1.28,0,0,1-1.7-.93c-.7-2.58,2.53-3.86,4.77-4-1.12-.72-4.31-2.65-2.7-3.73s5.41,1.72,6.64,2.65c1.81,1.35,4,3.4,4.14,5.62C656.49,226.23,654.15,224.72,652.77,224.23Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.77,224.23c-1.77.13-2.78,3-4.13,3.88a1.33,1.33,0,0,1-2-.23c-1.44-1.86.35-4.29,2.07-5.68-1.25.57-2.26,1.52-3.61,1.83a1.28,1.28,0,0,1-1.7-.93c-.7-2.58,2.53-3.86,4.77-4-1.12-.72-4.31-2.65-2.7-3.73s5.41,1.72,6.64,2.65c1.81,1.35,4,3.4,4.14,5.62C656.49,226.23,654.15,224.72,652.77,224.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.3,224.65c-2.31-1-6.61.7-7-.14-.82-1.72,2.62-3,4.49-3.36-1.75-.4-5.09-1-5.06-2.69,0-2,5.08-.48,7.66,1.35,3.26,2.3,3.33,4.64,2.82,5.13C655.51,225.61,653.68,224.8,653.3,224.65Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.3,224.65c-2.31-1-6.61.7-7-.14-.82-1.72,2.62-3,4.49-3.36-1.75-.4-5.09-1-5.06-2.69,0-2,5.08-.48,7.66,1.35,3.26,2.3,3.33,4.64,2.82,5.13C655.51,225.61,653.68,224.8,653.3,224.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.6,248.59a104,104,0,0,0,3.32,15.34.38.38,0,0,0,.74-.15c-.7-4.73-2-9.36-2.68-14.09a70.08,70.08,0,0,1-.82-14.47c.45-8,2.61-16.43,7.81-22.67.11-.14-.13-.35-.25-.21-10.4,12.13-8.75,27-8.74,28.33-1.47-5-3-10.78-8.56-15.89-.24-.22-.43-.12-.39.26,1,9.31,3.59,14.18,9,19.16C665.17,245.67,665.36,247.14,665.6,248.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.06,214c1.87-.83,4.45,1.55,6.31,1.71a1.52,1.52,0,0,0,1.87-1.3c.46-2.68-2.68-4.18-5.18-4.66,1.58-.09,3.13.33,4.67-.09a1.48,1.48,0,0,0,1.22-1.87c-.69-3-4.66-2.56-7-1.49.75-1.33,3-5,.72-5.25s-4.57,4.68-5.32,6.29c-1.1,2.36-2.2,5.62-1.17,8C671.37,218,672.92,215.2,674.06,214Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.06,214c1.87-.83,4.45,1.55,6.31,1.71a1.52,1.52,0,0,0,1.87-1.3c.46-2.68-2.68-4.18-5.18-4.66,1.58-.09,3.13.33,4.67-.09a1.48,1.48,0,0,0,1.22-1.87c-.69-3-4.66-2.56-7-1.49.75-1.33,3-5,.72-5.25s-4.57,4.68-5.32,6.29c-1.1,2.36-2.2,5.62-1.17,8C671.37,218,672.92,215.2,674.06,214Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.75,214.66c1.83-2.21,7.1-2.86,7.06-3.94-.11-2.19-4.32-1.68-6.39-1,1.56-1.36,4.63-3.8,3.68-5.48-1.16-2.06-5.42,2.26-7.06,5.53-2.06,4.11-.86,6.53-.08,6.75C672,216.85,673.44,215,673.75,214.66Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.75,214.66c1.83-2.21,7.1-2.86,7.06-3.94-.11-2.19-4.32-1.68-6.39-1,1.56-1.36,4.63-3.8,3.68-5.48-1.16-2.06-5.42,2.26-7.06,5.53-2.06,4.11-.86,6.53-.08,6.75C672,216.85,673.44,215,673.75,214.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.75,251.4l-4.59,35.06h27.92c-.57-3.11-5.77-35.1-5.77-35.1Z",
    style: {
      fill: "#FF2727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.48,426.46c1.51.49,2.86,1.6,3.72.12s3.17-1,4-1.35,2.06-2.8,2-3.58-.7-1.57-.7-2.31,0-1.83-.14-2.85-.19-2.46-1.76-3.19a7.76,7.76,0,0,0-3.48-.56c-1-.1-1.72-1.69-3.69-2.3s-4.56,1.6-4.79,2.49-.41,3.57-1.15,4.57-1.76.67-1.93,1.91-.11,3.29.25,3.66,1.32-.18,1.76.57.84,2.72,1.74,3.17S642.32,426.08,643.48,426.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "627.09 366.08 625.17 368.02 625.1 367.31 625.1 367.3 626.33 366.08 627.09 366.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "634.39 366.08 627.84 372.67 625.73 374.76 625.7 374.33 625.7 374.31 625.67 374.07 627.45 372.28 633.68 366.08 634.39 366.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641.69 366.08 631.5 376.34 626.31 381.5 626.3 381.39 626.25 380.82 631.11 375.94 641.03 366.08 641.69 366.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "648.99 366.08 635.17 380 626.88 388.23 626.83 387.59 634.77 379.61 648.37 366.08 648.99 366.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.26,366.08c-1,1-2,2-3,3l-14.46,14.56L627.45,395l0-.6,11-11.11L653,368.81c.91-.92,1.84-1.82,2.77-2.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.53,366.08q-3.28,3.36-6.58,6.69L642.5,387.32,628,401.7l0-.56,14.11-14.21,14.56-14.46c2.15-2.14,4.31-4.26,6.48-6.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.76,366.08c-3.37,3.47-6.76,6.91-10.16,10.36L646.15,391,631.6,405.44c-1,1-2,2-3,3l0-.47c.9-.94,1.83-1.87,2.75-2.8l14.46-14.55,14.54-14.45c3.4-3.37,6.83-6.72,10.25-10.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.89,366.16v0q-6.78,7-13.62,13.89l-14.46,14.55L635.27,409.1l-6.11,6,0-.37q2.89-3,5.84-5.94l14.45-14.55L664,379.8Q670.89,372.95,677.89,366.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.23,374.05v0l0,.24v0q-4.62,4.73-9.27,9.44l-14.45,14.54-14.55,14.46q-4.59,4.53-9.21,9v0l0-.22q4.44-4.56,8.93-9.09l14.45-14.55,14.55-14.46Q672.42,378.74,677.23,374.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.55,381.94l0,.49q-2.44,2.51-4.91,5L657.14,402,642.6,416.43q-5.94,5.86-11.94,11.7h-.13c3.89-4,7.82-8,11.75-12l14.47-14.55,14.54-14.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.88,389.86l0,.64-.57.58-14.45,14.55-14.56,14.45c-2.71,2.7-5.44,5.37-8.17,8.05h-.33q4.1-4.19,8.2-8.35l14.45-14.54L675,390.78C675.27,390.48,675.57,390.16,675.88,389.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.2,397.84l-.06.7-10.68,10.75-14.55,14.46c-1.47,1.47-2.95,2.92-4.44,4.38H645c1.53-1.57,3.07-3.12,4.61-4.68l14.46-14.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.53,405.8l-.07.77L668.12,413l-14.54,14.45c-.25.23-.48.48-.73.72h-.58c.34-.34.67-.69,1-1l14.45-14.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "673.85 413.77 673.78 414.61 671.79 416.62 660.2 428.13 659.56 428.13 671.39 416.23 673.85 413.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "673.18 421.77 673.18 421.81 673.11 422.61 667.56 428.13 666.87 428.13 673.18 421.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "677.8 367.3 677.73 368.03 675.8 366.08 676.57 366.08 677.8 367.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "677.23 374.07 677.16 374.76 675.05 372.67 668.5 366.08 669.22 366.08 675.45 372.28 677.23 374.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "676.64 380.82 676.6 381.39 676.59 381.51 671.39 376.34 661.2 366.08 661.87 366.08 671.79 375.94 676.64 380.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "676.07 387.6 676.02 388.24 667.73 380 653.9 366.08 654.52 366.08 668.12 379.61 676.07 387.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.5,394.38l0,.59-11.38-11.3-14.46-14.56q-1.5-1.5-3-3h.51c.93.91,1.85,1.81,2.77,2.73l14.55,14.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.92,401.14l0,.56L660.4,387.32,646,372.77q-3.3-3.33-6.59-6.69h.41c2.16,2.13,4.33,4.25,6.48,6.39l14.56,14.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.35,407.94l0,.48c-1-1-2-2-3-3L656.75,391l-14.47-14.54c-3.39-3.45-6.77-6.89-10.14-10.36h.21c3.42,3.34,6.85,6.69,10.25,10.06l14.54,14.45,14.46,14.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.77,414.74l0,.37c-2-2-4.09-4-6.12-6l-14.55-14.45L638.63,380.1q-6.86-6.92-13.62-13.89v0q7,6.79,13.92,13.64l14.55,14.45,14.45,14.55C669.89,410.78,671.83,412.76,673.77,414.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.2,421.55l0,.26q-4.63-4.5-9.21-9l-14.55-14.46L635,383.77q-4.65-4.71-9.27-9.44v0l0-.26q4.82,4.68,9.6,9.4l14.54,14.46,14.46,14.55Q668.76,417,673.2,421.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.37,428.13h-.13q-6-5.83-11.94-11.7L645.76,402,631.3,387.42q-2.46-2.49-4.91-5l0-.49c1.76,1.73,3.52,3.45,5.26,5.18l14.55,14.45,14.45,14.55C664.54,420.11,668.48,424.1,672.37,428.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.15,428.13h-.33c-2.74-2.68-5.46-5.35-8.17-8.05l-14.56-14.45-14.45-14.55-.57-.58-.05-.63c.31.29.61.61.92.91l14.56,14.46L657,419.78Q661.06,424,665.15,428.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.89,428.13h-.46c-1.49-1.46-3-2.91-4.45-4.38l-14.54-14.46-10.69-10.74,0-.71,11.13,11.06,14.46,14.55C654.82,425,656.37,426.56,657.89,428.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.63,428.13h-.58l-.73-.72L634.77,413l-6.33-6.38-.07-.78,6.8,6.76,14.45,14.55C650,427.44,650.29,427.79,650.63,428.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "643.34 428.13 642.7 428.13 631.11 416.62 629.12 414.61 629.12 414.6 629.04 413.79 631.5 416.23 643.34 428.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.03 428.13 635.34 428.13 629.79 422.61 629.72 421.77 636.03 428.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.28,
    y: 366.08,
    width: 1.12,
    height: 62.18,
    transform: "translate(-33.49 58.68) rotate(-5.21)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 644.11,
    y: 396.61,
    width: 62.18,
    height: 1.12,
    transform: "translate(217.74 1033.06) rotate(-84.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.74,
    y: 359.31,
    width: 59.33,
    height: 10.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.86,
    y: 422.75,
    width: 47.09,
    height: 10.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.81,419c1.78-.25,4.08-.25,4.2.77s-.68,1.57-.42,2.08,1.7,1.44,2.38,2.12a5,5,0,0,1,1.18,2.12c0,.26.43.68,0,1.19s-.66,1.28-1,1.66a1,1,0,0,0,0,1.48c.5.68.08,2.63-.68,3.31s-3-.93-3.65-.76-.77.5-1.36.93a6.64,6.64,0,0,1-3.57,1.45c-1.53,0-2.29-1.36-3.23-2a13,13,0,0,0-2.63-1,4.79,4.79,0,0,1-1.95-1.44c-.17-.34-.76-.42-.51-1.36s.68-1.19.68-2,0-.9,0-1.76-.69-2.4-.1-3.08,1-1.7,2-1.7,3.9.51,3.9.51a8,8,0,0,0,.85-1.1,2.44,2.44,0,0,1,2.06-1.19A6.31,6.31,0,0,0,670.81,419Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.24,427.59c1.21.56,2.45,1.06,3.69,1.55s2.47,1,3.71,1.47a34.56,34.56,0,0,0,3.74,1.21,3.17,3.17,0,0,0,.77.09l.75-.38a11.65,11.65,0,0,0,1.63-1,4.59,4.59,0,0,0,1.23-1.26,3,3,0,0,0,.18-.36l.06-.19,0-.08h0a1.46,1.46,0,0,0-.33-.57,18.4,18.4,0,0,0-2.9-2.53c-1.06-.79-2.17-1.53-3.29-2.23-.56-.37-1.13-.72-1.7-1.05-.29-.16-.59-.32-.88-.46a3.82,3.82,0,0,0-.46-.21c-.14,0-.33-.16-.45,0,.1-.16.33-.06.48-.05l.49.13c.32.11.63.23.95.36.62.25,1.23.54,1.84.83,1.19.61,2.36,1.28,3.5,2a15.32,15.32,0,0,1,3.24,2.57,2.11,2.11,0,0,1,.59,1.18,1.09,1.09,0,0,1,0,.25l0,.16-.09.29a3.84,3.84,0,0,1-.25.54,5.59,5.59,0,0,1-1.52,1.61,13.73,13.73,0,0,1-1.79,1.08l-.46.22-.23.11-.12.06-.25.07a3.16,3.16,0,0,1-1.21-.12,25.87,25.87,0,0,1-3.81-1.45A50.74,50.74,0,0,1,660.24,427.59Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.31,429.89a22.64,22.64,0,0,1,2.2-2.93c.4-.47.83-.9,1.27-1.34.22-.22.46-.42.7-.63a4.25,4.25,0,0,1,.9-.59l.16-.06a1.09,1.09,0,0,1,.36,0,1,1,0,0,1,.47.25,3.11,3.11,0,0,1,.35.42c.19.28.36.54.51.81a18.25,18.25,0,0,1,.82,1.66,14.61,14.61,0,0,1,1.16,3.49l-1.93-3.08c-.32-.51-.62-1-.95-1.52-.17-.24-.32-.49-.49-.71a2.28,2.28,0,0,0-.23-.27s0,0,.08,0a.19.19,0,0,0,.13,0l0,0a3.65,3.65,0,0,0-.62.4l-.67.56-1.37,1.17C667.22,428.36,666.3,429.16,665.31,429.89Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.73,437.25c-1,.23-2.22.35-2.34-.2s.29-.9.12-1.16a10.14,10.14,0,0,0-1.41-1,2.69,2.69,0,0,1-.76-1.11c0-.13-.27-.35-.06-.65s.3-.73.47-1,.23-.46-.08-.81a1.83,1.83,0,0,1,.21-1.85c.38-.41,1.68.36,2,.23s.39-.31.7-.58a3.67,3.67,0,0,1,1.87-1c.84-.08,1.33.62,1.87.9a6.68,6.68,0,0,0,1.5.42,2.79,2.79,0,0,1,1.14.69c.11.18.44.2.35.72s-.31.69-.27,1.11,0,.49.09,1,.49,1.28.2,1.68-.47,1-1,1-2.17-.08-2.17-.08a4.64,4.64,0,0,0-.4.65,1.37,1.37,0,0,1-1.07.75A3.44,3.44,0,0,0,642.73,437.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639,431.8c.51-.55,1.07-1,1.59-1.56l.41-.37.21-.19a1.08,1.08,0,0,1,.41-.2,5.62,5.62,0,0,1,1.19-.15,11.24,11.24,0,0,1,2.31.13,3.85,3.85,0,0,1,1.24.38,1.24,1.24,0,0,1,.55.77,2.24,2.24,0,0,1,.09.7,7.4,7.4,0,0,1-.52,2.35,9.4,9.4,0,0,1-.5,1.07,4.53,4.53,0,0,1-.33.53,1.43,1.43,0,0,1-.62.48,5.76,5.76,0,0,1-2.38.15,15.07,15.07,0,0,1-2.23-.39c.75-.05,1.5-.06,2.23-.15a7,7,0,0,0,2-.4c.14-.08.1-.08.21-.23a4.34,4.34,0,0,0,.23-.43,8.38,8.38,0,0,0,.37-1,6.35,6.35,0,0,0,.4-2,.82.82,0,0,1,.26-.53,6.94,6.94,0,0,0-1.22-.28,14.82,14.82,0,0,0-2.12-.3,7.13,7.13,0,0,0-1,0c-.07,0-.13,0-.11,0l-.23.15-.48.31C640.33,431,639.7,431.45,639,431.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.35,430.37c0,.72,0,1.4.06,2,0,.29.1.65.17.67s0,0,0,0,0,0,.07,0a2.05,2.05,0,0,0,.39,0c.6-.1,1.25-.28,1.9-.42a13.49,13.49,0,0,1,2.05-.33,8.26,8.26,0,0,1-3.78,1.85,2.54,2.54,0,0,1-.63,0,1.26,1.26,0,0,1-.43-.1.94.94,0,0,1-.4-.36,1.9,1.9,0,0,1-.18-1.31A5,5,0,0,1,641.35,430.37Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.63,422.69c-.5-1.51-.41-3.25-2.11-3.07s-2.72-1.94-3.48-2.45-3.48,0-4.08.51-.85,1.5-1.44,1.94-1.44,1.12-2.21,1.8-1.86,1.61-1.53,3.31a7.59,7.59,0,0,0,1.62,3.13c.51.86-.34,2.39.34,4.34s4,2.72,4.84,2.38,3.11-1.78,4.36-1.78,1.58,1,2.68.42,2.72-1.87,2.81-2.38-.94-.95-.6-1.75,1.7-2.28,1.53-3.28S635,423.85,634.63,422.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.48,419.44a48.16,48.16,0,0,0-6.12,2.44,3.51,3.51,0,0,0-.62.41c-.07,0-.12.39-.17.62-.09.53-.16,1.08-.22,1.62-.11,1.09-.19,2.19-.2,3.27a11.49,11.49,0,0,0,.09,1.58,1.36,1.36,0,0,0,.11.42,2,2,0,0,0,.6.18,16.08,16.08,0,0,0,3.2.16,13.82,13.82,0,0,0,1.59-.13c.46-.07,1.08-.22,1.6-.32,1.08-.21,2.17-.42,3.21-.69.25-.07.52-.14.72-.22l.13,0h0a.18.18,0,0,0-.08.11.52.52,0,0,0,0,.4.48.48,0,0,0,.1.19l.07.06h0l-.15-.06c-.47-.15-1-.28-1.55-.41l-3.23-.72c-1.08-.23-2.16-.47-3.25-.75-.54-.14-1.08-.28-1.63-.47a2.54,2.54,0,0,1-.91-.47.38.38,0,0,1-.09-.12.59.59,0,0,1-.09-.2v-.2a1,1,0,0,1,.06-.31,2.19,2.19,0,0,1,.2-.46,14,14,0,0,1,2.1-2.7c.2-.2.4-.4.61-.59l.34-.28.19-.14a.76.76,0,0,1,.27-.14.81.81,0,0,1,.63.15,2.84,2.84,0,0,1,.37.3,7,7,0,0,1,.59.63,43,43,0,0,1,3.61,5.6,52,52,0,0,0-4-5.24,5.9,5.9,0,0,0-.57-.55,1.27,1.27,0,0,0-.43-.28l-.08.06-.14.11a3.71,3.71,0,0,0-.29.27c-.19.18-.37.38-.55.58a12.69,12.69,0,0,0-1.85,2.61,1.1,1.1,0,0,0-.12.31s0,.1,0,.09h0a.49.49,0,0,0,0-.11l0,0a3.1,3.1,0,0,0,.58.22c.5.16,1,.3,1.56.42,1.07.26,2.15.48,3.23.7l4.14.79c.55.13.2.11.78.3l.24.08.17.09.14.12a.82.82,0,0,1,.14.23.68.68,0,0,1-.05.46.88.88,0,0,1-.23.24.63.63,0,0,1-.15.1,1.6,1.6,0,0,1-.25.11c-.31.12-.58.19-.86.27-1.1.27-2.19.46-3.28.66-.57.1-1,.21-1.66.31s-1.14.09-1.71.11a17.21,17.21,0,0,1-3.41-.23,2.63,2.63,0,0,1-1-.35,1.09,1.09,0,0,1-.39-.58,1.89,1.89,0,0,1-.09-.49,9.14,9.14,0,0,1,0-1.73c.06-1.13.19-2.23.36-3.34.08-.55.17-1.1.29-1.65.11-.29,0-.54.38-.92a3.11,3.11,0,0,1,.78-.47,27,27,0,0,1,3.16-1.11C629.33,420,630.4,419.67,631.48,419.44Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trash--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "644.72 255.84 642.28 286.46 625.44 286.46 623 255.84 644.72 255.84",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.41,
    y: 253.08,
    width: 24.76,
    height: 4.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.47 253.08 623.11 253.08 624.36 248.06 643.22 248.06 644.47 253.08",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.9,271.42c0,4-2.17,7.2-4.85,7.2s-4.85-3.23-4.85-7.2,2.17-7.2,4.85-7.2S642.9,267.44,642.9,271.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "595.53 267.01 626.15 269.45 626.15 286.29 595.53 288.73 595.53 267.01",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "595.53 267.01 626.15 269.45 626.15 286.29 595.53 288.73 595.53 267.01",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.11,272c4,0,7.2,2.62,7.2,5.85s-3.23,5.85-7.2,5.85-7.2-2.62-7.2-5.85S607.14,272,611.11,272Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.53,
    cy: 277.87,
    rx: 4.27,
    ry: 10.86,
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.16 425.93 337.54 423.5 337.54 406.65 368.16 404.22 368.16 425.93",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.58,414.73c-4,0-7.2-2-7.2-4.4s3.23-4.4,7.2-4.4,7.2,2,7.2,4.4S356.56,414.73,352.58,414.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.16,
    cy: 415.08,
    rx: 4.27,
    ry: 10.86,
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.16,
    cy: 415.08,
    rx: 4.27,
    ry: 10.86,
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clothes--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.48,185.09c-.15-.7-8.31-1.84-12-1.84s-10.09-.41-11.17,0-3.32,1.44-3.32,1.84,3.74,22.52,4.07,24.6c.23,1.45-9.76,16.25-14.14,24.3-1.89,3.46-.32,9.49.17,10.12,1.25,1.58,41-23.28,42-26.36s-2.05-7.88-2.72-10.47S632.81,186.6,632.48,185.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.83,221.09a9.49,9.49,0,0,1,.15-6.5,8.75,8.75,0,0,1,2.64-3.55,10.68,10.68,0,0,1,4-1.89c.08,0,.11.11,0,.13a9.09,9.09,0,0,0-6.35,9.71,9.72,9.72,0,0,0,.44,1.92,8,8,0,0,0,.37.92c.14.3.31.51.21.85a.33.33,0,0,1-.4.2C629.3,222.74,629,221.6,628.83,221.09Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.09,233a5.59,5.59,0,0,1,3.24-.87,14.3,14.3,0,0,1,3.51.43,14.09,14.09,0,0,1,3.22,1.23,14.73,14.73,0,0,1,1.42.89,5.5,5.5,0,0,1,1.3,1.1c.05.08,0,.2-.13.15a13,13,0,0,1-1.28-.79,16.21,16.21,0,0,0-1.49-.78,17.75,17.75,0,0,0-3.09-1.1,10.81,10.81,0,0,0-6.49.14A.23.23,0,0,1,597.09,233Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.37,304s7.48-1.72,9-1.72,7.76.81,10,.86,9.12-.16,10.27,0,4.8.86,4.8.86-6.89,5.23-8.33,8.83,0,19.21-4.8,17.88S601,323,599.51,320.2s-7.64-4.07-9.2-7.18A53.31,53.31,0,0,1,587.37,304Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.93,213.13s7.56-1.61,9.39-1.28a34,34,0,0,0,6.07.62c1.91,0,8.31-.67,10.48,0s7.06,21.16,8.39,32.05-3.57,39.82-3.57,39.82H85.26s8.31-32.84,8.39-39.15S83.93,213.13,83.93,213.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,295.23c-1.72-1.53-11.86-2.49-14.18-2.38s-24.39.65-29.93,0-25.61,3.78-28.82,5.66-18.29,48-18.29,48,15,11,21.17,12.53,46-5.1,46-5.1,3.21-29.71,3.44-31.7,2.88-6.88,2.88-6.88l3.1,8.43s10.31-2,13-3.11,10.53-6.44,10.53-6.44S175.52,296.6,174,295.23Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.72,337.17c0,.07,0,.13,0,.2a8.15,8.15,0,0,1-1.11-.26,8.39,8.39,0,0,1-2.61-1.25,10.17,10.17,0,0,1-2.09-2,20.7,20.7,0,0,1-2.79-5c-.73-1.77-1.33-3.6-1.92-5.42s-1.15-3.65-1.81-5.45a31.59,31.59,0,0,0-2.35-5.2,13.25,13.25,0,0,0-3.73-4.25,10,10,0,0,0-2.53-1.27,10.94,10.94,0,0,0-2.78-.53,11.24,11.24,0,0,0-5.52,1.13,20.53,20.53,0,0,0-4.72,3.19,41.87,41.87,0,0,0-4,4.1c-1.25,1.44-2.43,2.94-3.6,4.46s-2.29,3.07-3.45,4.6-2.23,2.95-3.43,4.35l-.1.12,0,0c-.63.73-1.28,1.44-2,2.1a14.5,14.5,0,0,1-2.22,1.83,6.47,6.47,0,0,1-2.66,1.09,4.15,4.15,0,0,1-1.45-.05,8.2,8.2,0,0,1-1.37-.47,6.62,6.62,0,0,1-2.29-1.73A9.13,9.13,0,0,1,89.7,329a13.56,13.56,0,0,1-.51-1.52l0-.14a13.58,13.58,0,0,0,.55,1.63,8.65,8.65,0,0,0,1.46,2.44,6.58,6.58,0,0,0,2.26,1.69,8.12,8.12,0,0,0,1.34.45,3.94,3.94,0,0,0,1.41.05,6.29,6.29,0,0,0,2.61-1.07,15.19,15.19,0,0,0,2.2-1.82c.68-.66,1.32-1.37,2-2.09l.07-.08a1.47,1.47,0,0,0,.1-.13c1.18-1.39,2.28-2.84,3.38-4.3s2.28-3.07,3.44-4.6,2.35-3,3.6-4.48a42.15,42.15,0,0,1,4-4.12,20.29,20.29,0,0,1,4.76-3.23,11.32,11.32,0,0,1,5.61-1.16,11.5,11.5,0,0,1,2.84.54,10.12,10.12,0,0,1,2.59,1.29,12,12,0,0,1,2.13,1.95,16.23,16.23,0,0,1,1.67,2.36,32.52,32.52,0,0,1,2.38,5.24c.66,1.8,1.23,3.63,1.82,5.45s1.17,3.65,1.9,5.41a20.7,20.7,0,0,0,2.74,5A9.15,9.15,0,0,0,151.72,337.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,350.19c0,.13,0,.25,0,.37-.06-.09-.12-.18-.17-.27a32.52,32.52,0,0,1-2.38-5.24c-.66-1.8-1.23-3.63-1.82-5.45s-1.17-3.64-1.9-5.41a20.63,20.63,0,0,0-2.74-5,9.74,9.74,0,0,0-10.2-3.32,15.89,15.89,0,0,0-5.08,2.52c-1.57,1.1-3,2.33-4.57,3.49a21.74,21.74,0,0,1-4.92,3q-.67.25-1.38.45a13.63,13.63,0,0,1-1.42.26,10.3,10.3,0,0,1-2.88-.1,8.59,8.59,0,0,1-2.74-.91,8.92,8.92,0,0,1-2.26-1.8,13.29,13.29,0,0,1-1.7-2.32c-.34-.58-.66-1.18-1-1.79l-.07-.14c-.1-.21-.2-.43-.29-.64a57,57,0,0,1-2-5.39L99.11,317c-.59-1.83-1.2-3.64-1.91-5.41-.37-.93-.78-1.84-1.21-2.73l0-.09c.46.91.88,1.84,1.26,2.78.73,1.78,1.35,3.59,1.94,5.41l1.73,5.48a54.21,54.21,0,0,0,2,5.38c.08.19.17.37.25.56a1,1,0,0,1,.07.15c.3.62.62,1.23,1,1.83a13.23,13.23,0,0,0,1.69,2.3,8.13,8.13,0,0,0,4.9,2.65,10.4,10.4,0,0,0,2.84.09,13.27,13.27,0,0,0,1.4-.26,10.68,10.68,0,0,0,1.35-.45,21.13,21.13,0,0,0,4.88-2.94c1.53-1.16,3-2.39,4.56-3.5a16.24,16.24,0,0,1,5.15-2.56,9.89,9.89,0,0,1,2.87-.33,11,11,0,0,1,2.85.46,8.36,8.36,0,0,1,2.61,1.24,10.22,10.22,0,0,1,2.09,2,20.82,20.82,0,0,1,2.79,5c.73,1.78,1.33,3.6,1.92,5.42s1.15,3.65,1.81,5.45a32.08,32.08,0,0,0,2.35,5.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shoes--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.52,435.05c-2.33.65-68.09-2.74-70.51-4.46-1.12-.79-1-14.8-.53-29.58l42.79,2.09-.6,7.7s24.6,12.56,27.05,14.73S551.86,434.4,549.52,435.05Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.72,432.37c-11-.84-55.49-3.18-66.44-3.18-.09,0-.09.06,0,.07,10.89,1.07,55.39,3.06,66.43,3.29C548.94,432.56,549,432.39,548.72,432.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.35,408.43c-4.29-1-9.63-.64-13.11,2.28-.13.11,0,.3.17.26a61.65,61.65,0,0,1,12.9-2A.28.28,0,0,0,522.35,408.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.39,410.48c-4.3-1-9.64-.64-13.11,2.28-.14.11,0,.3.17.26a61.66,61.66,0,0,1,12.89-2A.28.28,0,0,0,525.39,410.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.42,412.53c-4.3-1-9.64-.64-13.11,2.28-.14.11,0,.3.17.26a60.37,60.37,0,0,1,12.89-2A.28.28,0,0,0,528.42,412.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.45,414.58c-4.29-1-9.63-.64-13.11,2.27-.13.12,0,.31.17.27a61,61,0,0,1,12.9-2A.27.27,0,0,0,531.45,414.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.88,398.81c-1.58-2.43-4.81-1.54-6.7-.11a23.18,23.18,0,0,0-7.19,9.59c0,.09,0,.14.09.16,0,.33.27.7.65.58,3.65-1.14,7.7-1.91,10.89-4.14C530.48,403.59,532.38,401.12,530.88,398.81Zm-8,7.36c-1.78.6-3.58,1.11-5.34,1.79a67.67,67.67,0,0,1,4.33-5.51,24.59,24.59,0,0,1,2.42-2.37c1.35-1.11,6.59-3.34,5.58,1.38C529.35,404.06,525,405.44,522.91,406.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506,406.59c3.5,1.71,7.61,1.84,11.39,2.41a.55.55,0,0,0,.56-.67.13.13,0,0,0,.07-.18,23.23,23.23,0,0,0-8.59-8.37c-2.09-1.11-5.41-1.5-6.6,1.15S504,405.59,506,406.59Zm-1.8-3.2c-1.72-4.5,3.8-3.1,5.3-2.22a23.41,23.41,0,0,1,2.76,2,66.11,66.11,0,0,1,5.13,4.77c-1.84-.39-3.7-.62-5.56-.94C509.64,406.58,505.17,405.88,504.22,403.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.48,
    cy: 420.23,
    r: 4.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,445.32c2.34.65,68.1-2.74,70.52-4.46,1.12-.79,1-14.8.52-29.58l-42.78,2.09.6,7.7s-24.6,12.56-27.06,14.73S395.62,444.67,398,445.32Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76,442.64c11-.84,55.49-3.18,66.44-3.18.09,0,.09.06,0,.07-10.89,1.07-55.39,3.06-66.43,3.29C398.54,442.83,398.53,442.66,398.76,442.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.13,418.7c4.29-1,9.63-.64,13.11,2.28.13.11,0,.3-.17.26a61.65,61.65,0,0,0-12.9-2A.28.28,0,0,1,425.13,418.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.09,420.75c4.3-1,9.64-.64,13.11,2.28.14.11,0,.3-.17.26a61.66,61.66,0,0,0-12.89-2A.28.28,0,0,1,422.09,420.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.06,422.8c4.3-1,9.64-.64,13.11,2.28.13.11,0,.3-.17.26a60.37,60.37,0,0,0-12.89-2A.28.28,0,0,1,419.06,422.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,424.85c4.29-1,9.63-.64,13.11,2.27.13.12,0,.31-.17.27a61,61,0,0,0-12.9-2A.27.27,0,0,1,416,424.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.86,415.16c3.19,2.23,7.24,3,10.89,4.14.37.12.65-.25.65-.58.07,0,.13-.07.09-.16A23.18,23.18,0,0,0,423.3,409c-1.89-1.43-5.12-2.32-6.7.11S417,413.86,418.86,415.16Zm-1.28-3.43c-1-4.72,4.22-2.49,5.58-1.38a24.59,24.59,0,0,1,2.42,2.37,67.67,67.67,0,0,1,4.33,5.51c-1.76-.68-3.56-1.19-5.34-1.79C422.44,415.71,418.13,414.33,417.58,411.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.63,411.2c-1.19-2.65-4.51-2.26-6.6-1.15a23.23,23.23,0,0,0-8.59,8.37.13.13,0,0,0,.07.18.54.54,0,0,0,.56.67c3.78-.57,7.89-.7,11.39-2.41C443.5,415.86,445.76,413.71,444.63,411.2Zm-9,6c-1.86.32-3.72.55-5.56.94a67.84,67.84,0,0,1,5.12-4.77,24.39,24.39,0,0,1,2.77-2c1.5-.88,7-2.28,5.3,2.22C442.31,416.15,437.83,416.85,435.63,417.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.65,430.87a4.26,4.26,0,1,1-4.26-4.26A4.25,4.25,0,0,1,464.65,430.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bagpack--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,349.33c-.48-.58,3.28-8,5.59-9s15.25,1.21,16.3,4-2.41,10.28-3.37,10.26-3.38-.71-3.76-1.33,1.94-5.34,1.38-6.35c-.73-1.35-8.07-2.57-8.91-1.93s-2.41,4.89-2.6,5.15S250.72,350.27,250,349.33Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.91,426.36c-3.71,4.92-14.54,10.32-20.43,10.33s-44.55-1.46-49.26-10.45c-4.28-8.19,15.38-58.12,29-72.68a17.67,17.67,0,0,1,3.52-3l.27-.16c11.68-6.64,31.28,1.36,33.72,2.52,3.79,1.81,8.8,6.23,10.34,14.33S278.64,421.43,274.91,426.36Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,419.29c-1.25,3.7-8.8,11.64-16.25,12.66s-32.53-5.71-37.37-11.69a5.83,5.83,0,0,1-.78-3.54c.09-11.77,13.22-45.21,23.14-54.33a9.43,9.43,0,0,1,3.1-2.05,22.61,22.61,0,0,1,4-1,43.59,43.59,0,0,1,22.37,2.85c4.26,1.82,7.56,4.33,8.75,7.37C264,377.26,255.25,415.59,254,419.29Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,419.29c-1.25,3.7-8.8,11.64-16.25,12.66s-32.53-5.71-37.37-11.69a5.83,5.83,0,0,1-.78-3.54,35.27,35.27,0,0,0,14.08,7.19,64.26,64.26,0,0,0,11.43,1.94c3.82.31,7.82.18,11.32-1.65,6.62-3.45,10.11-11.61,12.14-18.58,2.21-7.61,3.08-15.67,3.76-23.54a94,94,0,0,0-.11-19.91c4.26,1.82,7.56,4.33,8.75,7.37C264,377.26,255.25,415.59,254,419.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.87,403.2l-1.72-.39c1.82-7.94,5.84-29.59,2.6-34.48s-18.16-8-24.76-7.1a29.93,29.93,0,0,0-5.25,1.16,9.85,9.85,0,0,1,3.1-2.06,23.51,23.51,0,0,1,4-1c7.87-.2,21.09,3.09,24.37,8C258.54,373.88,252.14,402,251.87,403.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.49,399.85l-1.74-.24c4.38-32.42,3.06-33.87-2.5-39.95l-.19-.21c-5.42-5.92-20.28-7.82-26.23-7.77a21.18,21.18,0,0,0-8.61,1.88,17.67,17.67,0,0,1,3.52-3,24,24,0,0,1,5.07-.6c4.17,0,21.1,1.29,27.54,8.35l.19.2C276.41,364.88,278,366.61,273.49,399.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.71,426.18c-1.66,4.05-12.91,10.76-18.06,11.74-1,.2-9.51.48-9.32-2.89,0-.22,0-.45,0-.67.77-8.75,7.52-26.87,8.82-29.25,1.53-2.8,11.74-6.85,17.45-7.07a6,6,0,0,1,3,.45C285.44,400.57,280.76,423.62,279.71,426.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.71,426.18c-1.66,4.05-12.91,10.76-18.06,11.74-1,.2-9.51.48-9.32-2.89,0-.22,0-.45,0-.67,6.11.52,15-.8,19.77-7.28,4.53-6.11,6.12-20.76,6.5-29a6,6,0,0,1,3,.45C285.44,400.57,280.76,423.62,279.71,426.18Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.74,187.05c-1.91-1.27-62-17.56-64.67-16.73-.29.09-.82,2.79-3.27,9.52-.11.32-27.15,35.61-27.15,35.61l39.44,19L546,202.54s27.44-6.24,30.29-7.45S582.65,188.32,580.74,187.05Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.74,187.05c-1.91-1.27-62-17.56-64.67-16.73-.29.09-.82,2.79-3.27,9.52-.11.32-3.82,4.95-5.63,7.46,2.54,2,26.89,17.93,33.61,23.26l5.26-8s27.44-6.24,30.29-7.45S582.65,188.32,580.74,187.05Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.59,175.69a9.12,9.12,0,0,1-1.07,1.93,9.33,9.33,0,0,1-3.3,2.88,8.87,8.87,0,0,1-4.32.95,10.57,10.57,0,0,1-4.25-1.19c-.07,0,0-.15.07-.11a9.07,9.07,0,0,0,8.2-.45,8.73,8.73,0,0,0,3-2.72,9.42,9.42,0,0,0,.94-1.74,7.8,7.8,0,0,0,.31-.93c.09-.33.11-.59.41-.78a.32.32,0,0,1,.43.1C528.32,174.13,527.8,175.18,527.59,175.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.58,197.15a6.72,6.72,0,0,1-3.3-2.41A17.49,17.49,0,0,1,563,191a17,17,0,0,1-1.31-4.09,17.92,17.92,0,0,1-.27-2.08,7.16,7.16,0,0,1,.05-2.12.13.13,0,0,1,.24,0,16.77,16.77,0,0,1,.24,1.87,20.8,20.8,0,0,0,.4,2.06,22.49,22.49,0,0,0,1.34,3.85,13.18,13.18,0,0,0,5.11,6.11A.29.29,0,0,1,568.58,197.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.54,203.37c-7.42-5-14.79-10-22.26-14.83-2.11-1.39-4.21-2.79-6.35-4.14a.06.06,0,1,1,.07-.1,246.05,246.05,0,0,1,22.69,14.19c2.06,1.48,4.07,3,6.06,4.59A.18.18,0,0,1,540.54,203.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.65,185.53a.56.56,0,0,1-.1.15l-.16.12-.31.22c-.21.15-.43.3-.66.44-.44.27-.89.52-1.34.76-.07,0-.13-.07-.07-.11.43-.28.84-.58,1.25-.89l.61-.44.31-.24a.89.89,0,0,1,.33-.18A.13.13,0,0,1,512.65,185.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.11,187.89a.56.56,0,0,1-.1.15l-.16.12-.31.22a7.57,7.57,0,0,1-.66.44c-.44.27-.89.52-1.34.77-.07,0-.13-.07-.07-.11.43-.29.84-.59,1.25-.89l.61-.45.31-.23a.92.92,0,0,1,.33-.19C516.06,187.71,516.15,187.81,516.11,187.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.57,190.26a.71.71,0,0,1-.1.14,1.67,1.67,0,0,1-.16.12l-.31.22a7.66,7.66,0,0,1-.66.45c-.44.27-.89.52-1.34.76-.07,0-.13-.07-.07-.11.43-.28.84-.58,1.25-.89.2-.15.4-.3.61-.44l.31-.24a.89.89,0,0,1,.33-.18A.13.13,0,0,1,519.57,190.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523,192.62a.56.56,0,0,1-.1.15l-.16.12-.31.22c-.21.15-.43.3-.66.44-.44.27-.89.52-1.34.76-.07,0-.13-.07-.07-.11.43-.28.84-.58,1.25-.89l.61-.44.31-.24a.89.89,0,0,1,.33-.18A.13.13,0,0,1,523,192.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.49,195a.56.56,0,0,1-.1.15l-.16.12-.31.22c-.21.15-.43.3-.66.44-.44.27-.89.52-1.34.77-.07,0-.13-.07-.07-.11.43-.29.84-.59,1.25-.89l.61-.45L526,195a.92.92,0,0,1,.33-.19C526.44,194.8,526.53,194.9,526.49,195Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530,197.35a.71.71,0,0,1-.1.14,1.67,1.67,0,0,1-.16.12l-.31.22a7.66,7.66,0,0,1-.66.45c-.44.27-.89.52-1.34.76-.07,0-.13-.07-.07-.11.43-.28.84-.58,1.25-.89.2-.15.4-.3.61-.44l.31-.24a.89.89,0,0,1,.33-.18A.13.13,0,0,1,530,197.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.41,199.71a.56.56,0,0,1-.1.15l-.16.12-.31.22c-.21.15-.43.3-.66.44-.44.27-.89.52-1.34.76-.07,0-.13-.07-.07-.11.43-.28.84-.58,1.25-.89l.61-.44.31-.24a.89.89,0,0,1,.33-.18A.13.13,0,0,1,533.41,199.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.87,202.07a.56.56,0,0,1-.1.15l-.16.12-.31.22c-.21.15-.43.3-.66.44-.44.27-.89.52-1.34.77-.07,0-.13-.07-.07-.11.43-.29.84-.59,1.25-.89l.61-.45.31-.23a.92.92,0,0,1,.33-.19C536.82,201.89,536.91,202,536.87,202.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.33,204.44a.71.71,0,0,1-.1.14,1.67,1.67,0,0,1-.16.12l-.31.22a7.66,7.66,0,0,1-.66.45c-.43.27-.89.52-1.34.76-.07,0-.13-.07-.07-.11.43-.28.84-.58,1.25-.89.2-.15.4-.3.61-.44l.31-.24a.89.89,0,0,1,.33-.18A.13.13,0,0,1,540.33,204.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.28,222.89l-37.46-29.64s-33.42,46.05-34,46.37c0,0-24.41,6.82-46.28,9.59-4,.5-29.91-7.13-48.42,8.93L377,295c37.36,4,88.93-5.9,110.77-13.94C508.41,273.52,538.28,222.89,538.28,222.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.27,222.55c-7.9-6.07-15.88-12-24.15-17.59-2.36-1.58-4.78-3.06-7.1-4.7-.08,0-.16.08-.08.13,2,1.47,3.95,3.06,5.94,4.57s4,3,6,4.48c4,2.94,8.14,5.71,12.25,8.51,2.34,1.59,4.71,3.16,7.08,4.73C531.28,222.73,531.35,222.61,531.27,222.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.19,209.62c-5.85,8.39-11.73,16.76-17.55,25.18q-4.36,6.31-8.74,12.61c-1.29,1.84-2.58,3.56-4.81,4.28a22.89,22.89,0,0,1-3.39.69l-3.78.6c-10,1.61-20.08,3.24-30.13,4.82a58.43,58.43,0,0,1-7.57.84,48.19,48.19,0,0,1-7.58-.66,59.31,59.31,0,0,0-13.71-.23,72,72,0,0,0-25.85,8c-1,.53-2,1.08-3,1.63-.09.05,0,.17.08.13a79.52,79.52,0,0,1,26.58-8.66,59.07,59.07,0,0,1,13.81-.22c2.45.26,4.89.72,7.36.87a38.52,38.52,0,0,0,7.58-.46c5.05-.72,10.08-1.6,15.12-2.4l15.13-2.43c2.51-.4,5-.75,7.53-1.21a9.22,9.22,0,0,0,5.4-2.63,47.23,47.23,0,0,0,4-5.63c1.47-2.17,2.95-4.32,4.43-6.48q8.64-12.65,17.21-25.35l2.16-3.17C506.51,209.65,506.28,209.49,506.19,209.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.9,125.88c-1.86,1.34-38.17,51.91-38.34,54.71,0,.3,2.33,1.74,7.77,6.39.26.22.59,2.13.94,5,1.29,10.77,2.92,35.17,2.92,35.17l39.54-11.25-8.32-41.35-2.16-10.75s3.77-27.88,3.62-31S483.76,124.53,481.9,125.88Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.9,125.88c-1.86,1.34-38.17,51.91-38.34,54.71,0,.3,2.33,1.74,7.77,6.39.26.22.59,2.13.94,5,6.41-3.39,26.13-13.38,34.14-17.43l-2.16-10.75s3.77-27.88,3.62-31S483.76,124.53,481.9,125.88Z",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.63,171.67a9.15,9.15,0,0,1,1.43,1.68,9.32,9.32,0,0,1,1.54,4.11,8.72,8.72,0,0,1-.62,4.37,10.67,10.67,0,0,1-2.6,3.57c-.06,0-.14-.05-.08-.1a9.13,9.13,0,0,0,2.46-7.85,9,9,0,0,0-1.52-3.71,9.71,9.71,0,0,0-1.3-1.49,7.73,7.73,0,0,0-.77-.62c-.27-.2-.51-.31-.59-.66a.32.32,0,0,1,.26-.36C451.43,170.45,452.23,171.31,452.63,171.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.1,140.8a6.7,6.7,0,0,1-3.42,2.25,17.36,17.36,0,0,1-4.28.84,16.58,16.58,0,0,1-4.28-.2,17.77,17.77,0,0,1-2-.48,7,7,0,0,1-2-.79.12.12,0,0,1,.08-.22,16.74,16.74,0,0,1,1.83.43c.69.15,1.38.26,2.07.34a22.28,22.28,0,0,0,4.08.1,13.29,13.29,0,0,0,7.52-2.65A.29.29,0,0,1,487.1,140.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.61,170.52c-7.88,4.17-15.79,8.28-23.63,12.53-2.22,1.2-4.46,2.38-6.66,3.62-.07,0-.12-.07-.06-.12a248.3,248.3,0,0,1,23.28-13.21c2.28-1.11,4.6-2.14,6.92-3.15A.18.18,0,0,1,483.61,170.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.66,186.57a.6.6,0,0,1,.08.16l0,.2c0,.12,0,.25.05.37s.06.53.07.79c0,.52,0,1,0,1.55,0,.07-.12.08-.12,0-.05-.51-.12-1-.19-1.53,0-.24-.07-.49-.1-.74l-.06-.39a.81.81,0,0,1,0-.38A.14.14,0,0,1,454.66,186.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.38,184.65a.4.4,0,0,1,.08.16,1.38,1.38,0,0,1,0,.2c0,.12,0,.25.05.37s.06.53.08.79c0,.52,0,1,0,1.55,0,.07-.12.08-.13,0,0-.51-.11-1-.19-1.53,0-.24-.07-.49-.1-.74l-.06-.39a.81.81,0,0,1,0-.38A.13.13,0,0,1,458.38,184.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.11,182.73a.8.8,0,0,1,.08.16l0,.2c0,.12,0,.25,0,.37s.06.53.07.79c0,.52,0,1,0,1.55,0,.07-.12.08-.12,0-.05-.5-.12-1-.19-1.52,0-.25-.07-.49-.11-.74s0-.26-.05-.39a.82.82,0,0,1,0-.38A.13.13,0,0,1,462.11,182.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.83,180.81a.48.48,0,0,1,.08.16l0,.2c0,.12,0,.25.05.37s.06.53.08.79c0,.52,0,1,0,1.55,0,.07-.12.08-.13,0-.05-.51-.11-1-.19-1.52,0-.25-.07-.49-.1-.74l-.06-.39a.81.81,0,0,1,0-.38A.12.12,0,0,1,465.83,180.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.55,178.89a.51.51,0,0,1,.09.16,1.36,1.36,0,0,1,0,.2c0,.12,0,.25,0,.37s.06.53.08.79c0,.52,0,1,0,1.55,0,.07-.12.08-.13,0,0-.51-.11-1-.19-1.52,0-.25-.06-.49-.1-.74s0-.26,0-.39a.7.7,0,0,1,0-.38A.12.12,0,0,1,469.55,178.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.28,177a.48.48,0,0,1,.08.16l0,.2c0,.12,0,.25.05.37s.06.52.07.79c0,.52,0,1,0,1.55,0,.07-.12.08-.12,0-.05-.51-.12-1-.19-1.52,0-.25-.07-.49-.1-.74l-.06-.39a1,1,0,0,1,0-.38A.13.13,0,0,1,473.28,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,175.05a.35.35,0,0,1,.08.16,1.38,1.38,0,0,1,0,.2c0,.12,0,.24.05.37s.06.52.08.79c0,.51,0,1,0,1.55,0,.07-.12.08-.13,0-.05-.51-.11-1-.19-1.52,0-.25-.07-.49-.1-.74l-.06-.39a.81.81,0,0,1,0-.38A.12.12,0,0,1,477,175.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.73,173.13a.8.8,0,0,1,.08.16l0,.2c0,.12,0,.24.05.37s.06.52.07.79c0,.51,0,1,0,1.55,0,.07-.12.08-.12,0-.05-.51-.12-1-.19-1.52,0-.25-.07-.49-.11-.74s0-.26-.05-.39a.82.82,0,0,1,0-.38A.13.13,0,0,1,480.73,173.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.45,171.21a.35.35,0,0,1,.08.16,1.2,1.2,0,0,1,0,.2c0,.12,0,.24.05.37s.06.52.08.79c0,.51,0,1,0,1.54a.07.07,0,0,1-.13,0c0-.51-.11-1-.19-1.52,0-.25-.07-.5-.1-.74l-.06-.39a.81.81,0,0,1,0-.38A.12.12,0,0,1,484.45,171.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.86,186.13l-39.94,10s6.93,58.09,6.78,58.74c0,0-20.46,3.43-36.95,3.12,0,0-28.18-12.92-46.32,8.52L371.06,303c50.26,1.26,122.18.73,130.88-17.54C511.38,265.66,488.86,186.13,488.86,186.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.59,254.62c-4.46.16-11.92,1.28-16.38,1.61s-8.84.76-13.26,1.15c-2.54.22-4.68.14-7.21.47a.08.08,0,0,0,0,.15A180,180,0,0,0,445,256.54c2.54-.33,8.19-1.13,10.71-1.6C455.83,254.91,456,254.61,455.59,254.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1,254.25a32.39,32.39,0,0,0-5.71-4.66c-.07-.05-.15.06-.09.12a56.67,56.67,0,0,1,5.16,5.12,49.23,49.23,0,0,1,4.81,5.59s.09,0,.07-.05A35.9,35.9,0,0,0,416.1,254.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.81,258.25c-.11-2-.34-4-.55-6.05-.41-4-.89-8-1.5-11.91-1.22-8-2.7-15.87-4.53-23.69-.51-2.18-1-4.37-1.6-6.53a65.78,65.78,0,0,0-1.89-6.56.15.15,0,0,0-.29.06c.32,1.93.84,3.84,1.28,5.73s.89,3.86,1.32,5.79q1.29,5.91,2.42,11.86c1.49,7.89,2.75,15.83,3.86,23.8.31,2.23.58,4.48.87,6.72.15,1.12.86,10.11.92,11.26a.07.07,0,1,0,.13,0C504.14,267.72,504,261.25,503.81,258.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.37,248.5c-.13-1.09-.65-5.28-1.1-6.08a.06.06,0,0,0-.1,0c-.27.94.3,5.26.44,6.35a59.48,59.48,0,0,0,1.12,6.08.07.07,0,0,0,.13,0A58.31,58.31,0,0,0,455.37,248.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.06,263.26c-.41-7.09-1.15-14.15-2.13-21.18-1.91-13.87-4.71-27.62-7.67-41.3q-.54-2.5-1.09-5c0-.1-.16-.05-.14.05,2.8,13.69,5.66,27.38,7.72,41.2,1,6.87,1.87,13.76,2.42,20.69.26,3.35.47,6.72.57,10.09a39.76,39.76,0,0,1-.47,8.44,15.61,15.61,0,0,1-3.44,7.5,18,18,0,0,1-7,4.54,64.45,64.45,0,0,1-8.82,2.56c-3.31.78-6.64,1.43-10,2-13.41,2.18-27,2.69-40.59,2.9-13.9.23-27.81.21-41.71.56-1.75.05-3.49.09-5.23.11-.1,0-.09.15,0,.15,7.17,0,14.35,0,21.52,0s14.22-.07,21.32-.13c13.73-.13,27.5-.43,41.11-2.38a132.51,132.51,0,0,0,19.52-4.1,26.93,26.93,0,0,0,7.6-3.41,14.35,14.35,0,0,0,5.05-6.12C493.9,275,493.38,268.88,493.06,263.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.15,192.44c-9.79,1.88-19.54,3.87-29.19,6.37-2.75.71-5.47,1.54-8.23,2.19-.09,0-.05.17,0,.14,2.44-.54,4.9-.92,7.35-1.4s4.89-1,7.33-1.51c4.86-1,9.68-2.29,14.5-3.5,2.75-.69,5.49-1.42,8.24-2.15C489.29,192.55,489.24,192.42,489.15,192.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.83,212.62c12.61,6,20.5,30.4,14.14,50.26-6.87,21.47-28.85,25.57-41.49,21C287.07,279,283,264.17,289.1,255.31c5.89-8.57,15.58-11.1,18.2-18.93,1.26-3.75,1.09-10.67,2.71-16.28C311.81,213.83,320.21,209,327.83,212.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.7,216A53.61,53.61,0,0,1,344,234.42,43.8,43.8,0,0,1,346.33,245a43.08,43.08,0,0,1,.11,5.45,49.33,49.33,0,0,1-.59,5.42c-1.21,7.14-4.13,14.17-9.16,19.49a31,31,0,0,1-8.72,6.45,31.59,31.59,0,0,1-10.38,3A31.56,31.56,0,0,0,336.25,275a37.09,37.09,0,0,0,8.85-19.21,50,50,0,0,0,.61-5.33,41.54,41.54,0,0,0-.08-5.35,45.22,45.22,0,0,0-2.23-10.48,54.38,54.38,0,0,0-4.47-9.79A55.78,55.78,0,0,0,332.7,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,227.25a33.46,33.46,0,0,1-.85,5.95,19.21,19.21,0,0,1-2.36,5.56,16,16,0,0,1-4.2,4.4c-1.64,1.16-3.26,2.3-4.82,3.54a29.88,29.88,0,0,0-7.92,8.7,17.81,17.81,0,0,0-2.08,11.47,17,17,0,0,1-.28-6,15.75,15.75,0,0,1,.67-2.95,18.21,18.21,0,0,1,1.18-2.8,29.22,29.22,0,0,1,8-9c1.58-1.25,3.25-2.38,4.88-3.51a16.38,16.38,0,0,0,4.1-4.16C307.25,235.18,308.15,231.18,308.71,227.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.39,220.56l7,27.21c.3.8-.1,1.45-.89,1.45l-14.06.06a2.25,2.25,0,0,1-1.95-1.44l-7-27.21c-.29-.8.11-1.45.89-1.45l14.06-.07A2.29,2.29,0,0,1,282.39,220.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.72,220.55l7,27.21c.3.8-.1,1.45-.89,1.45l-14.05.07a2.29,2.29,0,0,1-2-1.44l-7-27.22c-.29-.8.11-1.45.89-1.45l14.06-.06A2.27,2.27,0,0,1,280.72,220.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.87,221.81a1.2,1.2,0,0,0,2.39-.06,1.21,1.21,0,0,0-1.23-1.17A1.2,1.2,0,0,0,276.87,221.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.91,262.31c-7.73,17-25.3,39.28-32.69,39.47-3.51.1-9.78,1-14.45-3-10.18-8.68-18.82-25.43-20.66-35.06-.66-3.42,15.94-11.08,18.45-8.32,5.86,6.47,12.74,19.23,13.76,19.14,3.78-.34,18.41-12.85,28.62-21.66C333.33,242.22,331,255.51,327.91,262.31Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.46,246c1.67-7,3.18-8.54,1.46-15.19-1.13-4.36,1.17-7,4.32-3.49,5.16,5.69,4.89,15.16,3.85,18.42Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,266.74s-3.24-9.67-2.19-17.3c.72-5.28,3.58-16.58,18.24-22.72,3.48-1.45,9.47-1.06,4.65,3.38-3.42,3.15-6.54,4.12-8.2,6.32,0,0,7.56,1.4,8.88,4.94a70.53,70.53,0,0,1,2.8,9.5,14.78,14.78,0,0,1-1.73.68s.92,3.43-1.51,8.24Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.26,244.52c2.11-1.84,6.63-5.65,11.42-7.48,5.32-2,16.11-4.51,17.57-.57,1.07,2.88-3,4.19-3,4.19s4.68-.08,5.07,2.74c.36,2.57-2.82,3.4-2.82,3.4s2.85.43,2.72,3c-.16,3.05-6.1,1.64-8.93,4.6C281.68,255.05,260.26,244.52,260.26,244.52Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.89,243a22.7,22.7,0,0,1,13.3-2.43c.12,0,.16.11.05.12a55.47,55.47,0,0,0-13.33,2.36S272.87,243,272.89,243Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.1,248.32a25.52,25.52,0,0,1,13.42-1.63c.11,0,.15.13.05.13a59.94,59.94,0,0,0-13.46,1.55S275.07,248.34,275.1,248.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.56,280.7l-11-18.83a164.85,164.85,0,0,1,12.81-11.28c6.55-4.79,9.87-3.48,7.69,6.23C328.56,263.32,320.56,280.7,320.56,280.7Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,277.75c-1.42-2.86-2.88-5.68-4.46-8.45q-1.18-2.06-2.43-4.1c-.83-1.35-1.8-2.62-2.61-4a.07.07,0,1,0-.11.07c.87,1.32,1.58,2.77,2.39,4.13s1.61,2.74,2.4,4.12c1.59,2.75,3.18,5.5,4.7,8.28C321.16,277.9,321.27,277.82,321.23,277.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,256.82c-1.45,6.49-9.45,23.88-9.45,23.88l-4.3-7.33,12-25.47C330.61,248,331.37,250.8,330,256.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.06,303.45a215.43,215.43,0,0,0,3.25-47.71s-24.56-5.58-33.56-8.56-15-.17-18.34,6c-.83,1.54-3.72,20.86-.27,28.55,2.71,6,12.85,7.45,12.85,7.45S346.58,298.77,371.06,303.45Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.58,303.15l-.25,0a275.75,275.75,0,0,0,3.33-47.75l.25.06A276.28,276.28,0,0,1,369.58,303.15Zm.63-48.36-.24,0a274.89,274.89,0,0,1-3.24,47.8l.24.06A273.78,273.78,0,0,0,370.21,254.79Zm-2.7-.63-.25-.06a273.26,273.26,0,0,1-3.13,47.82l.25.07A274.12,274.12,0,0,0,367.51,254.16Zm-2.71-.64-.25-.06a272.09,272.09,0,0,1-3,47.78l.24.06A272,272,0,0,0,364.8,253.52Zm-2.71-.65-.24-.06A270.64,270.64,0,0,1,359,300.49l.24.07A270.48,270.48,0,0,0,362.09,252.87Zm-2.7-.66-.26-.07a269.16,269.16,0,0,1-2.73,47.54l.25.08A270.24,270.24,0,0,0,359.39,252.21Zm-2.72-.67-.25-.07a267.49,267.49,0,0,1-2.58,47.33l.25.09A268.4,268.4,0,0,0,356.67,251.54Zm-2.72-.69-.24-.06a265.66,265.66,0,0,1-2.42,47.06l.24.09A265.78,265.78,0,0,0,354,250.85Zm-2.71-.69-.26-.07a262.23,262.23,0,0,1-2.24,46.71l.24.11A264,264,0,0,0,351.24,250.16Zm-2.73-.73-.26-.07a259.06,259.06,0,0,1-2.06,46.32l.25.11A260.56,260.56,0,0,0,348.51,249.43Zm-2.74-.74-.24-.07a255.91,255.91,0,0,1-1.86,45.84l.24.12A256.22,256.22,0,0,0,345.77,248.69ZM343,247.9l-.25-.08a252.24,252.24,0,0,1-1.65,45.3l.24.14A253.08,253.08,0,0,0,343,247.9ZM340.3,247,340,247a247.91,247.91,0,0,1-1.41,44.69l.23.15A249.71,249.71,0,0,0,340.3,247Zm-2.74-.7-.26-.05c.38,4.8,1.3,21-1.17,43.73l.24.16A245.17,245.17,0,0,0,337.56,246.34Zm-2.71-.34h-.26c.36,4.33,1.35,20.29-1,42.9l.25.05C336.19,266.35,335.21,250.39,334.85,246Zm-2.69.1-.25,0c.37,4.49,1.3,20.06-1,42l.24.08C333.46,266.2,332.53,250.58,332.16,246.1Zm-2.64.61-.24.09a241.82,241.82,0,0,1-.92,40.39l.24.11A240.72,240.72,0,0,0,329.52,246.71Zm-2.59,1.3a1.88,1.88,0,0,0-.23.16,246.91,246.91,0,0,1-.89,37.62l.23.14A244.19,244.19,0,0,0,326.93,248Zm-2.56,2.28a1.54,1.54,0,0,0-.23.29,252.1,252.1,0,0,1-.82,33l.23.27A250.35,250.35,0,0,0,324.37,250.29Zm-2.51,5c-.08.38-.15.79-.22,1.25.09,5.51,0,12.79-.57,21.44.05.32.12.64.19.94C321.94,269.21,322,261.16,321.86,255.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.11,253.32c10.31,16.32,23.83,43.58,16.28,48.71-12.41,8.44-46.66,10.85-54.49,11.09-3.38.1-8.1-22.35-5.61-25s38.36-1.4,38.8-3.56c.26-1.23-1.68-12.15-4-25.72C333.48,243.21,342.16,248.65,345.11,253.32Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.3,286.87s-10.24-1-17-1.34c-3.75-.19-10.21.05-13,1.17-4.22,1.68-20.79,11.39-18.52,15.45,2,3.69,15.23-6.46,15.23-6.46s-14.21,9.06-10.92,13,16.65-9.46,16.65-9.46-14.38,9.64-10.35,13.21c3.06,2.69,15.85-8.8,15.85-8.8S272.94,312.05,276,315c3.33,3.21,15.81-6.66,15.81-6.66,8.91,6.1,15.65,5.36,20.39,4.26C313.3,312.3,307.3,286.87,307.3,286.87Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.73,292.24c-1.71,1-3.44,2-5.06,3.16s-3.18,2.36-4.68,3.66a33.79,33.79,0,0,0-5.34,5.6c3-3.46,8.74-7.67,10.36-8.83s3.15-2.38,4.76-3.53A0,0,0,0,0,278.73,292.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,298c-2.12,1.37-4.28,2.66-6.34,4.13s-3.88,3-5.82,4.63c-.15.13,0,.17.12.05,2-1.52,4-2.77,6-4.27s4-3.08,6.07-4.5C283.06,298,283,298,283,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.54,302.26a56.77,56.77,0,0,0-9.22,7.06c-.14.13,0,.17.17,0,3-2.4,5.37-4.31,9.12-7C287.67,302.33,287.61,302.22,287.54,302.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,286.23c-1.43,0-6.44.39-9.82.22-7.6-.37-18.31-1.48-22.14-1.52-4.53-.06-7.59.85-9.59,2.37-.75.57-1,1-.23.54,3.28-1.88,5.89-2.35,10.76-2.31,3.34,0,13.54,1,21.2,1.35a72.42,72.42,0,0,0,9.82-.47C317.07,286.4,317.07,286.23,317,286.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3,274,336.56,272a164.24,164.24,0,0,1-1.64-17c-.05-8.12,3-10,9.55-2.59C348.88,257.36,358.3,274,358.3,274Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.21,272.22c-.23-.07-2.45-.35-2.62-.33-.16-1.28-1-7.27-1.07-7.89a.07.07,0,1,0-.13,0c0,.37.11,1.73.22,3.27l0-.06c-.12-.28-.26-.56-.4-.83s-.24-.59-.35-.88a.08.08,0,0,0-.14.06c.12.28.26.56.36.85s.18.55.28.81.21.54.32.8l0,0c.12,1.73.27,3.49.38,4.14a24.48,24.48,0,0,0,3.16.08S339.25,272.23,339.21,272.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.29,271.76c-3.14-.52-6.29-1-9.46-1.33-1.58-.17-3.16-.31-4.74-.43s-3.18-.08-4.76-.22c-.09,0-.1.13,0,.14,1.58.06,3.17.33,4.75.48s3.16.29,4.75.46c3.15.32,6.31.64,9.46,1C356.37,271.91,356.37,271.77,356.29,271.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.44,262.26s-.07,0-.05,0a132.21,132.21,0,0,0,6.69,11.56,13.77,13.77,0,0,0-1.7,0,13.77,13.77,0,0,0,2.21.27C358.64,274.12,352.17,263.06,351.44,262.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.8,252.06c-1.41,4.21-1.82,17.27,2.67,17.06s11.44-16.29,10.43-20.27S323.94,245.65,321.8,252.06Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,250.64c-.1,1-3.93,7.89-8.4,8.25-1.45.11-2.43-7.8-2.43-7.8l-.2-.56-2.87-7.95,8.82-7.39,1.28-1s.65,2.23,1.42,5c0,.12.07.25.11.39s.09.3.13.45c.12.42.24.84.35,1.26s.18.64.25,1l.26,1A54.25,54.25,0,0,1,332,250.64Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.61,239.21A17,17,0,0,1,321,250.53l-2.87-7.95,8.82-7.39,1.28-1S328.84,236.43,329.61,239.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.26,228.7c-1.76,14.72,6.86,17.44,10,17.81,2.88.34,12.73,1.14,16-13.33s-3-19.93-9.57-21.06S307,214,305.26,228.7Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.24,226.78a8.49,8.49,0,0,0,1-.16,1.63,1.63,0,0,0,1-.36.53.53,0,0,0,0-.64,1.29,1.29,0,0,0-1.27-.37,1.9,1.9,0,0,0-1.24.62A.56.56,0,0,0,308.24,226.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.81,227.46c-.34-.06-.65-.17-1-.26a1.7,1.7,0,0,1-1-.46.54.54,0,0,1,0-.64,1.32,1.32,0,0,1,1.31-.25,2,2,0,0,1,1.17.74A.57.57,0,0,1,317.81,227.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.66,231.1s.07.05.07.09c-.11,1-.06,2.17.83,2.57,0,0,0,.07,0,.06C315.45,233.58,315.4,232,315.66,231.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,230.11c1.63,0,1.52,3.25,0,3.26S315.27,230.11,316.63,230.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.27,230.3c.27.2.54.53.88.58s.71-.28,1-.6c0,0,.06,0,.05,0,0,.62-.27,1.25-.94,1.33s-1-.51-1.17-1.14C317.05,230.39,317.15,230.23,317.27,230.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,230.57s-.08.05-.08.09c0,1-.15,2.17-1.08,2.48,0,0,0,.06,0,.05C310,233.07,310.18,231.53,310,230.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.14,229.49c-1.62-.16-1.83,3.09-.33,3.24S310.5,229.63,309.14,229.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.45,229.66c-.27.16-.55.46-.86.46s-.59-.37-.8-.72c0,0-.05,0-.05,0-.06.62.11,1.28.69,1.44s1-.37,1.16-1C308.63,229.78,308.55,229.6,308.45,229.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.32,238.81c-.24.24-.47.56-.84.6a2.78,2.78,0,0,1-1.09-.24,0,0,0,0,0,0,.05,1.37,1.37,0,0,0,1.29.53,1.08,1.08,0,0,0,.78-.9C315.44,238.79,315.36,238.77,315.32,238.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.27,235s-.28,1.5-.31,2.21c0,.06.17.1.41.13h0a3.39,3.39,0,0,0,3.34-1.11c.05-.07,0-.15-.11-.11a5.06,5.06,0,0,1-3.12.75c0-.2.56-2.55.45-2.56a6.3,6.3,0,0,0-1.63.29c.48-3.13,1.46-6.17,1.9-9.29a.1.1,0,0,0-.19-.06,51.52,51.52,0,0,0-2.47,9.93C309.49,235.55,311,235.08,311.27,235Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.78,237.12a3.81,3.81,0,0,0,1.44,1.25,1.67,1.67,0,0,0,1,.13c.75-.15.81-.83.71-1.42a4,4,0,0,0-.28-.92A4.89,4.89,0,0,1,311.78,237.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.22,238.37a1.67,1.67,0,0,0,1,.13c.75-.15.81-.83.71-1.42A1.73,1.73,0,0,0,313.22,238.37Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,234.88a6.1,6.1,0,0,1-3.16-5.12,15.85,15.85,0,0,1-6.2-5.51c.08.31.69,2.53,1,3.66-9.27-2.2-11.81-9.5-11.81-9.5a16.16,16.16,0,0,0-4.37,5.73s.21-5.74,3.35-9.44a9.26,9.26,0,0,1,8.72-3.4,13.23,13.23,0,0,1,12.72,4.61C336.65,222.82,330.62,234.88,330.62,234.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.26,226a17,17,0,0,0,4.71,2s0,0,0,0a14.69,14.69,0,0,1-6.66-4.49,13.6,13.6,0,0,1-1.88-2.92,9.47,9.47,0,0,1-1.07-3.62c0-.1-.15-.09-.15,0a11.43,11.43,0,0,0,.57,3.72,10.42,10.42,0,0,0,1.92,3.2,11.61,11.61,0,0,0,2.56,2.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,234s3.38-4.53,5.44-3.31-.58,7.85-3.08,8.69a2.5,2.5,0,0,1-3.31-1.45Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.47,232.62s0,0,0,.06a6.36,6.36,0,0,0-3.4,3.86,1.38,1.38,0,0,1,2.08-.31s0,.1-.05.09a1.55,1.55,0,0,0-1.72.48,7.5,7.5,0,0,0-.85,1.35c-.09.15-.36.06-.3-.12l0,0C329.28,235.79,331.09,232.76,333.47,232.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.27,
    y: 110.21,
    width: 143.51,
    height: 7.17,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.44,
    y: 117.39,
    width: 7.17,
    height: 23.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.44,
    y: 117.39,
    width: 7.17,
    height: 7.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.44,
    y: 117.39,
    width: 7.17,
    height: 23.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.44,
    y: 117.39,
    width: 7.17,
    height: 7.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.46 110.21 368.56 110.2 366.78 110.2 363.87 110.19 352.5 110.19 344.84 89.86 353.38 82.33 355.56 80.41 356.89 79.24 359.07 77.32 372.83 80.7 378.57 74.1 388.24 99.78 379.56 98.59 371.46 110.21",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.46 110.21 368.56 110.2 356.89 79.24 359.07 77.32 371.46 110.21",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.78 110.2 363.87 110.19 353.38 82.33 355.56 80.41 366.78 110.2",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.24,
    y: 81.61,
    width: 45.7,
    height: 11.51,
    transform: "translate(382.46 -207.73) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.58,
    y: 74.26,
    width: 5.02,
    height: 11.51,
    transform: "translate(375.11 -215.08) rotate(90)",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.16,
    y: 68.71,
    width: 1.86,
    height: 11.51,
    transform: "translate(369.55 -220.63) rotate(90)",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.58,
    y: 95.96,
    width: 5.02,
    height: 11.51,
    transform: "translate(396.8 -193.38) rotate(90)",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.03,
    y: 79.54,
    width: 53.31,
    height: 8.04,
    transform: "translate(498.49 -183.32) rotate(109.79)",
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.25,
    y: 70.42,
    width: 20.5,
    height: 4.83,
    transform: "translate(493.51 -201.28) rotate(109.79)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 97.17,
    width: 37.64,
    height: 6.67,
    style: {
      fill: "#FF2727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.39,
    y: 97.17,
    width: 1.64,
    height: 6.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.2,
    y: 97.17,
    width: 1.64,
    height: 6.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.01,
    y: 97.17,
    width: 1.64,
    height: 6.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.74,
    y: 82.08,
    width: 40.49,
    height: 13.66,
    transform: "translate(286.76 -255.14) rotate(67.03)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.59,
    y: 95.04,
    width: 3.77,
    height: 13.66,
    transform: "translate(302.03 -252.29) rotate(67.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.76,
    y: 90.34,
    width: 1.46,
    height: 13.66,
    transform: "translate(296.5 -253.32) rotate(67.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.83,
    y: 103.85,
    width: 34.38,
    height: 6.37,
    transform: "translate(542.04 214.06) rotate(180)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.57,
    y: 106.29,
    width: 20.9,
    height: 1.49,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.57,
    y: 72.87,
    width: 38.05,
    height: 9.43,
    transform: "translate(418.32 -180.53) rotate(102.51)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 85.77,
    width: 3.55,
    height: 9.43,
    transform: "translate(427.44 -162.03) rotate(102.51)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.86,
    y: 63.68,
    width: 3.55,
    height: 9.43,
    transform: "translate(411.83 -193.69) rotate(102.51)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.89,
    y: 68.45,
    width: 1.38,
    height: 9.43,
    transform: "translate(415.2 -186.85) rotate(102.51)",
    style: {
      fill: "#c7c7c7"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutterCuate);
export default __webpack_public_path__ + "static/media/Clutter-cuate.4abd7a13876b2318a20992bda07b9b69.svg";
export { ForwardRef as ReactComponent };